import { Input as AntInput } from 'antd'
import type { ComponentProps } from 'react'
import { SIZE_MAP } from '../types'
import type { Size } from '../types'

type AntPasswordProps = ComponentProps<typeof AntInput.Password>

export interface AppPasswordInputProps extends Omit<AntPasswordProps, 'size'> {
  size?: Size
}

export const AppPasswordInput = ({ size = 'md', ...rest }: AppPasswordInputProps) => (
  <AntInput.Password size={SIZE_MAP[size]} {...rest} />
)
